import * as React from "react"

function SvgFeatherNavigation2(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather-navigation-2_svg__feather feather-navigation-2_svg__feather-navigation-2"
      {...props}
    >
      <path d="M12 2l7 19-7-4-7 4 7-19z" />
    </svg>
  )
}

export default SvgFeatherNavigation2
